import script from "./MoneyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoneyPage.vue?vue&type=script&setup=true&lang=ts"

import "./MoneyPage.vue?vue&type=style&index=0&id=fcbb79ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcbb79ea"]])

export default __exports__